function getContextFromProvider(contextId, element) {
  const ctxSymbol = Object.getOwnPropertySymbols(element).find(
    (s) => s.description === "element-context",
  );
  if (!ctxSymbol) {
    throw new Error("No context provider found for the provided element");
  }
  // @ts-ignore
  const contexts = element[ctxSymbol];
  return contexts[contextId];
}

function useRouter(element) {
  const hashRoute = element.closest("hash-router");
  if (!hashRoute)
    throw console.warn(
      "bundle-builder: Must be used within a hash-router custom element!",
    );

  const routerContext = getContextFromProvider(
    hashRoute.routerContextId,
    hashRoute,
  );

  if (!routerContext)
    throw new console.warn("No router context found for the provided element");
  return routerContext;
}

function useLocation(element) {
  const context = useRouter(element);
  return context.location;
}

function useNavigate(element) {
  const context = useRouter(element);
  return context.navigatorFactory();
}

function publishEvent(eventName, data) {
  if (typeof window.Shopify.analytics === "undefined") return;
  return Shopify.analytics.publish(eventName, data);
}

function onRouteChange(callback) {
  // Before the user leaves the page (includes refresh, navigation, and closing tab)
  window.addEventListener("beforeunload", (event) => {
    callback("beforeunload");
  });

  // Detects when the page is hidden (useful for mobile navigation gestures)
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      callback("visibilitychange");
    }
  });
}

// Example usage:
// onRouteChange((eventType, url) => {
//   console.log(`Navigation detected: ${eventType}`, url || "");
// });

window.BundleUtils = {
  getContextFromProvider,
  useRouter,
  useLocation,
  useNavigate,
  publishEvent,
  onRouteChange,
};
